module.exports = {
  youtubeKey: "AIzaSyBDo-PGnKPvfiLi61vz2487RZOemynlcCQ",
  analyticsKey: "UA-110456026-1",
  rss2jsonKey: "r7gntvw6vverseytseq2tgr0gftxwgpai0ldffpc",
  mailchimpKey:
    "https://clearmatics.us10.list-manage.com/subscribe/post?u=8fb5debdb7d2d973e444bcdff&id=a55b1ade2c"
};
